import React from 'react';

import {
    ToggleSwitch,
    Input,
} from '../Form';

const AustraliaForm = (props) => {
    const {
        memberId,
        australiaTennisConnectId,
    } = props;

    return (
        <div className="row bt pt40">
            <div className="col-md-4">
                <h5 className={`text-uppercase`} data-testid="australiaform.h5-17">Australia Users</h5>
            </div>
            <div className="col-md-6 mt56">
                <>
                    <div className={`form-group form-group-xl`}>
                        <label data-testid="australiaform.label-22">UTR Sports ID</label>
                        <div className="input-wrapper">
                            <input
                                className="form-control"
                                value={memberId}
                                disabled
                            />
                        </div>
                    </div>
                    <Input
                        label={'Tennis ID'}
                        id="tennisConnectId"
                        field="tennisConnectId"
                        type="text"
                        placeholder="Not Linked."
                        disabled
                        data-testid="settings.tennis-connect-id-input"
                    />
                    <ToggleSwitch
                        id={'marketingEmailsOptIn'}
                        field={'marketingEmailsOptIn'}
                        formGroupCssClass={`mt16`}
                        label={<span>I would like to receive email communication from UTR Sports <br /> including product updates, marketing initiatives, contents and more</span>}
                        reverse={false}
                    />
                </>
            </div>
        </div>
    );
};

export default AustraliaForm;
